import { z } from 'zod/v3';

// Doc DTOs
export const DocDTOSchema = z.object({
  id: z.string(),
  content: z.string().nullable(),
  plateContent: z.any().optional(),
  metadata: z.record(z.any()).nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
  createdBy: z.string(),
  editedBy: z.string().optional(),
  publishedBy: z.string().optional(),
  firstPublishedAt: z.date().optional(),
  topicId: z.string(),
  topic: z.string(),
  currentFor: z.string().optional(),
  contentHash: z.string().nullable(),
  // RFC-086: Version locking fields for evidence generation
  latestPublishedCommit: z.string().nullable().optional(),
  latestContentHash: z.string().nullable().optional(),
  publishedCommit: z.string().nullable().optional(),
  templateId: z.string().nullable().optional(),
  templateVersion: z.number().nullable().optional(),
  templateSnapshot: z.any().nullable().optional(),
}).strict();

export const DocListDTOSchema = z.object({
  id: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
}).strict();

export const CreateDocDTOSchema = z.object({
  branchId: z.string().optional(),
  topicId: z.string(),
  plateContent: z.any(), // JSON
  metadata: z.record(z.any()).optional(),
  workspaceId: z.string(),
  fromFlow: z.boolean().optional(),
  flowId: z.string().optional(),
  templateId: z.string().optional().nullable(),
  templateVersion: z.number().optional().nullable(),
  templateSnapshot: z.any().optional().nullable(),
}).strict();

export const UpdateDocDTOSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  branchId: z.string().optional(),
  content: z.string().optional(),
  plateContent: z.any().optional(),
  metadata: z.record(z.any()).optional(),
  topicId: z.string().optional(),
  currentFor: z.string().optional(),
  editedBy: z.string().optional(),
  lastServerContentHash: z.string().nullable().optional(),
  fromFlow: z.boolean().optional(),
  flowId: z.string().optional(),
  templateId: z.string().optional().nullable(),
  templateVersion: z.number().optional().nullable(),
  templateSnapshot: z.any().optional().nullable(),
}).strict();

export const PublishDocDTOSchema = z.object({
  docId: z.string(),
});

export type DocDTO = z.infer<typeof DocDTOSchema>;
export type DocListDTO = z.infer<typeof DocListDTOSchema>;
export type CreateDocDTO = z.infer<typeof CreateDocDTOSchema>;
export type UpdateDocDTO = z.infer<typeof UpdateDocDTOSchema>;
export type PublishDocDTO = z.infer<typeof PublishDocDTOSchema>;
